import { Button, IconButton, Tooltip, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { MenuBook } from '@material-ui/icons'
import { APPOINTMENT_GUIDES_TITLE, EventType, Route } from 'constants/'
import { useEventTracking } from 'hooks'
import { useStyles } from './index.styles'

const AppointmentGuidesButton = () => {
  const classes = useStyles()
  const theme = useTheme()
  const { track } = useEventTracking()
  // Below md the header has no room for the label, so only the icon is shown
  const isCompact = useMediaQuery(theme.breakpoints.down('md'))

  const trackClick = () => track(EventType.APPOINTMENT_GUIDES_BUTTON_CLICKED)

  const linkProps = {
    href: Route.APPOINTMENT_GUIDES,
    // A middle-click also opens the guides in a new tab
    onAuxClick: trackClick,
    onClick: trackClick,
    rel: 'noopener',
    target: '_blank',
  }

  if (isCompact) {
    return (
      <Tooltip title={APPOINTMENT_GUIDES_TITLE}>
        <IconButton aria-label={APPOINTMENT_GUIDES_TITLE} className={classes.iconButton} {...linkProps}>
          <MenuBook />
        </IconButton>
      </Tooltip>
    )
  }

  return (
    <Button className={classes.button} startIcon={<MenuBook />} variant="outlined" {...linkProps}>
      {APPOINTMENT_GUIDES_TITLE}
    </Button>
  )
}

export { AppointmentGuidesButton }
